// extracted by mini-css-extract-plugin
module.exports = {"shape":"styles_shape__3a7W5"};